import ImageCropper from "./image_cropper_controller"

// Connects to data-controller="cover-cropper"
//
// The beta org profile's inline "Edit cover photo" (Facebook-style): pick a
// file, crop it in the shared modal, and the form posts immediately — there is
// no surrounding settings form with its own Save button to press afterwards.
//
// Everything about picking, validating and cropping is inherited. The only
// addition is submitting once the cropped file is on the input.
export default class extends ImageCropper {
  // The parent calls showImage() at the end of a successful crop, AFTER it has
  // written the cropped File onto uploadFieldTarget.files — so this is the one
  // safe place to submit. Submitting from cropImage() would race the async
  // canvas.toBlob() and post the original (or nothing).
  showImage() {
    super.showImage()

    // The controller is mounted ON the form, so `closest` covers both that and
    // any future nesting.
    const form = this.element.matches("form") ? this.element : this.element.closest("form")
    form?.requestSubmit()
  }
}
